import { api } from "./api";

export const listarFichas = (params = {}) => {
  const qs = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
  ).toString();
  return api.get(`/ficha/listar${qs ? `?${qs}` : ""}`);
};
export const obterFicha = (id) => api.get(`/ficha/${id}`);
export const salvarFicha = (dto) => api.post("/ficha/salvar", dto);
export const excluirFicha = (id) => api.post(`/ficha/excluir/${id}`);
export const analisarFicha = (id, dto) => api.post(`/ficha/analisar/${id}`, dto);
export const liberarEdicao = (id) => api.post(`/ficha/liberar-edicao/${id}`);
export const getRelatorio = (id) => api.get(`/ficha/relatorio/${id}`);
export const notificarIndeferimento = (id) => api.post(`/ficha/notificar-indeferimento/${id}`);
export const notificarIncompleta = (id) => api.post(`/ficha/notificar-incompleta/${id}`);
export const enviarParaAnalise = (id) => api.post(`/ficha/enviar-analise/${id}`);

/** Monta a query dos filtros da grid (usada também nas exportações). */
const queryFichas = (f = {}) => {
  const q = new URLSearchParams();
  if (f.termo) q.set("termo", f.termo);
  if (f.grupo && f.grupo !== "todas") q.set("grupo", f.grupo);
  if (f.entrega && f.entrega !== "todas") q.set("idSituacaoEntrega", f.entrega);
  if (f.idEdicao) q.set("idEdicao", f.idEdicao);
  return q.toString();
};

/**
 * Baixa a listagem no formato pedido, respeitando os filtros da tela.
 * Vai pelo axios (e não por window.open) para que o token de autenticação seja enviado.
 */
export const exportarFichas = async (formato, filtros) => {
  const qs = queryFichas(filtros);
  const { data } = await api.get(`/ficha/exportar/${formato}${qs ? `?${qs}` : ""}`, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = `fichas_${new Date().toISOString().slice(0, 10)}.${formato === "excel" ? "xlsx" : "pdf"}`;
  document.body.appendChild(a); a.click(); a.remove();
  window.URL.revokeObjectURL(url);
};
